import { createFrontendModule } from '@backstage/frontend-plugin-api';
import { SignInPageBlueprint } from '@backstage/plugin-app-react';

/**
 * Replaces the default sign-in page (extension id `sign-in-page:app`)
 * with the Regask one: GitHub-only sign-in in every environment.
 */
const regaskSignInPage = SignInPageBlueprint.make({
  params: {
    loader: () => import('./RegaskSignInPage').then(m => m.RegaskSignInPage),
  },
});

export const authModule = createFrontendModule({
  pluginId: 'app',
  extensions: [regaskSignInPage],
});
